import { ClientPathSchema } from '@/features/dashboard/client/clientSchema'
import { ClientDetail } from '@/features/dashboard/client/detail/ClientDetail'
import { IdentificationEditReturnTo } from '@/features/dashboard/client/identification-list/identificationListEnum'
import { usePageTitle } from '@/hooks/usePageTitle'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

const ClientDetailSearchSchema = z.object({
  returnTo: z.enum(Object.values(IdentificationEditReturnTo)).optional(),
});

export const Route = createFileRoute('/_dashboard/clients/$clientId/')({
  component: RouteComponent,
  parseParams: ClientPathSchema.parse,
  validateSearch: ClientDetailSearchSchema,
})

function RouteComponent() {
  usePageTitle('顧客詳細')
  return <ClientDetail />
}
